import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GoogleTagManagerService {
  addGtmToDom(): void {
    const id = environment.googleTagManagerId;
    const auth = environment.googleTagManagerAuth;
    const preview = environment.googleTagManagerPreview;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${id}&gtm_auth=${auth}&gtm_preview=${preview}`;

    document.head.appendChild(script);
  }
}
